/* Mixed-edition picker (snippets/yansh-mix.liquid), 2026-10-18. Keeps the order box summary, total and the
   next-discount line in step with "this box x tier + any other editions". Store discounts: 30 off 2 boxes, 45 off 3+,
   counted across editions. yansh-cart.js adds window.ynXsItems() to the cart on submit. */
(function(){
  var mix=document.getElementById('mix'),form=document.getElementById('buyForm');
  if(!mix||!form)return;
  var MAX=3,q={};
  var $=function(id){return document.getElementById(id)};
  function off(n){return n>=3?4500:n===2?3000:0}
  function tier(){return form.querySelector('#tiers input:checked')}
  function items(){return [].map.call(mix.querySelectorAll('.mix-t'),function(t){return {id:Number(t.getAttribute('data-vid')),quantity:q[t.getAttribute('data-vid')]||0}}).filter(function(i){return i.quantity})}
  function upd(){
    var t=tier();if(!t)return;
    var self=Number(mix.getAttribute('data-self')),n=Number(t.value),cents=self*n,extra=[];
    [].forEach.call(mix.querySelectorAll('.mix-t'),function(el){
      var k=q[el.getAttribute('data-vid')]||0;
      el.classList.toggle('on',k>0);el.querySelector('.mix-add').hidden=k>0;el.querySelector('.mix-q').hidden=!k;
      el.querySelector('.mix-q span').textContent=k;el.querySelector('.mix-q [data-mix="1"]').disabled=k>=MAX;
      if(k){n+=k;cents+=Number(el.getAttribute('data-unit'))*k;extra.push(k+' '+el.getAttribute('data-w'))}
    });
    var tot=Math.round((cents-off(n))/100),w=t.getAttribute('data-word')+(extra.length?' + '+extra.join(' + '):'');
    if($('sum'))$('sum').innerHTML='נבחר: '+w+' <b>'+tot+' ₪</b>';
    if($('bbTxt'))$('bbTxt').innerHTML=w+'<b>'+tot+' ₪</b>';
    if($('buyAmt'))$('buyAmt').textContent=tot+' ₪';
    var nd=$('mixNudge');
    if(nd)nd.innerHTML=n===1?'<b>עוד קופסה אחת, מכל מהדורה,</b> וחוסכים 30 ₪.':n===2?'<b>חוסכים 30 ₪.</b> עם קופסה שלישית ההנחה עולה ל־45 ₪.':'<b>חוסכים 45 ₪</b> על כל ההזמנה.';
  }
  mix.addEventListener('click',function(e){
    var b=e.target.closest('[data-mix]');if(!b)return;
    var vid=b.closest('.mix-t').getAttribute('data-vid');
    q[vid]=Math.max(0,Math.min(MAX,(q[vid]||0)+Number(b.getAttribute('data-mix'))));
    upd();
    if(q[vid]&&b.classList.contains('mix-add')){var p=b.closest('.mix-t').querySelector('.mix-q [data-mix="1"]');if(p)p.focus()}
  });
  form.addEventListener('change',function(){setTimeout(upd)});
  // after every deferred script (yansh-xsell.js also defines these), so ours win
  document.addEventListener('DOMContentLoaded',function(){
    window.ynXsItems=items;
    window.ynXsReset=function(){q={};upd()};
    upd();
  });
})();
